import { Component, OnInit, ElementRef } from '@angular/core';
import { ChartService } from 'app/assessment-charts/services/chart.service';
import * as Chart from 'chart.js';

export abstract class BaseChartComponent implements OnInit {

  private _timeoutHandler:any;
  private _configOptions:any;
  private chart:Chart;
  private chartNode:HTMLCanvasElement;
  private chartImage:HTMLImageElement;

  constructor(private chartElement:ElementRef, private cs:ChartService) {}

  ngAfterViewInit() {
    this.drawChart();
  }
  ngOnDestroy() {
   this.clearChartConversionTimeout();
    this.destroyChart();
    this.destroyChartImage();
  }

  protected abstract setupChartData();
  protected abstract getLabelData() : any;
  protected abstract getDatasets() : any;
  protected getMaxYAxisTick() : number {
    return 100;
  }

  protected getChart() : Chart {
    return this.chart;
  }

  private calculateStepSize(maxValue) {
    // TODO: stephen we override the system since we set a max value, but is there a better way?
    if (maxValue > 100) {
      return 25;
    }
    else if (maxValue > 50) {
      if (maxValue % 20 == 0) {
        return 20;
      }
      if (maxValue % 15 == 0) {
        return 15;
      }
      return 10;
    }
    else if (maxValue > 25) {
      if (maxValue % 9 == 0) {
        return 9;
      }
      else if (maxValue % 8 == 0) {
        return 8;
      }
      else if (maxValue % 7 == 0) {
        return 7;
      }
      else if (maxValue % 6 == 0) {
        return 6;
      }
      // by default just return 10 if we have to.
      return 5;
    }
    else if (maxValue > 10) {
      if (maxValue % 3 == 0) {
        return 3;
      }
      return 2;
    }
    else {
      return 1;
    }
  }

  protected setupChartConfiguration() {

    let maxY = this.getMaxYAxisTick();
    let stepSize = this.calculateStepSize(maxY);
    // let stepSize = maxY / 6 > 
    let configOptions:any = { 
      responsive: true,
      showDatapoints: true,
      dataPointFontSize: 18,
      maintainAspectRatio: true,
      title: {
        display: false
        ,text: "some title goes here"
      }
      ,legend: {
        display: false
      }
      ,layout: {
          padding: {
              left: 0,
              right: 0,
              top: 0,
              bottom: 0
          }
      }
      ,tooltips: {
        enabled: false
        // mode: "index",
        // intersect: true
      }
      // ,elements: { 
      //   point: { 
      //     radius: 0 // should hide the points from displaying...
      //     ,hoverRadius: 0
      //   } 
      // }
      ,annotation: {
        events: ["click"],
        annotations: []
      }
      ,scales: {
        xAxes: [{
          stacked: false
          ,scaleLabel: {}
          ,ticks: {}
          ,gridLines: {}
        }]
        ,yAxes: [{
          ticks: {
            min: 0
            ,max: this.getMaxYAxisTick()
            ,stepSize: stepSize
            , padding: 0
          }
          ,stacked: false
          ,scaleLabel: {
            display: true
          }
        }]
      }
    };
    
    // convert the canvas chart to an image
    configOptions.animation = {
      onComplete: this.handleChartAnimationComplete.bind(this)
    };
    return configOptions;
  }

  ngOnInit() {
    this.setupChartData();
    this._configOptions = this.setupChartConfiguration();
  }

  protected handleChartAnimationComplete(e:any) {
    // this.convertChartToImage(e);
  }

  private clearChartConversionTimeout() {
    if (this._timeoutHandler) {
      clearTimeout(this._timeoutHandler);
      this._timeoutHandler = null;
    }
  }

  public convertChartToImage(e:any) {
    // since we are destroying the chart we want to get it out
    // of the current chart onComplete event cycle.
    this._timeoutHandler = setTimeout(() => {
      this._timeoutHandler = null;
      if (this.chartNode && this.chartNode.parentNode) {
        let dataUrl = this.chartNode.toDataURL('image/png');
        this.chartImage = new Image();
        this.chartImage.src = dataUrl;
        this.chartNode.parentNode.appendChild(this.chartImage);
        // now that the chart has been created let's destroy the chart
        this.destroyChart();
      }
    }, 0);
  }

  private destroyChart() {
    if (this.chart) {
      this.cs.destroyChart(this.chart);
      this.chart = null;
    }

    if (this.chartNode) {
      if (this.chartNode.parentNode) {
        this.chartNode.parentNode.removeChild(this.chartNode);
      }
      this.chartNode = null;
    }
  }

  private destroyChartImage() {
    if (this.chartImage) {
      if (this.chartImage.parentNode) {
        this.chartImage.parentNode.removeChild(this.chartImage);
      }
      this.chartImage = null;
    }
  }

  public drawChart() {
    var chartData = {
      labels: this.getLabelData()
      ,datasets: this.getDatasets()
    };
    this.drawChartWithData(chartData);
  }

  private drawChartWithData(data) {
    this.chartNode = this.createChartNode();
    if (this.chartNode) {
      this.chart = this.cs.drawChart(this.chartNode, data, this._configOptions);
    }
  }

  private createChartNode() {
    let componentElement = this.chartElement.nativeElement as Element;
    let element = componentElement.querySelector(".scale-chart-container");
    if (!element) {
      console.error("could not find element with class .scale-chart-container");
      return null;
    }

    let chartNode = document.createElement("canvas") as HTMLCanvasElement;
    element.appendChild(chartNode);
    chartNode = chartNode;
    return chartNode;

  }
}



// WEBPACK FOOTER //
// ./src/app/assessment-charts/base-chart/base-chart.component.ts